/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { WeatherSnowflakeIcon16Light } from './WeatherSnowflakeIcon16Light';
import { WeatherSnowflakeIcon16Regular } from './WeatherSnowflakeIcon16Regular';
import { WeatherSnowflakeIcon16Solid } from './WeatherSnowflakeIcon16Solid';
import { WeatherSnowflakeIcon20Light } from './WeatherSnowflakeIcon20Light';
import { WeatherSnowflakeIcon20Regular } from './WeatherSnowflakeIcon20Regular';
import { WeatherSnowflakeIcon20Solid } from './WeatherSnowflakeIcon20Solid';
import { WeatherSnowflakeIcon24Regular } from './WeatherSnowflakeIcon24Regular';
import { WeatherSnowflakeIcon24Solid } from './WeatherSnowflakeIcon24Solid';
import { WeatherSnowflakeIcon32Regular } from './WeatherSnowflakeIcon32Regular';
import { WeatherSnowflakeIcon64Regular } from './WeatherSnowflakeIcon64Regular';
var sizes = {
    16: {
        light: WeatherSnowflakeIcon16Light,
        regular: WeatherSnowflakeIcon16Regular,
        solid: WeatherSnowflakeIcon16Solid,
    },
    20: {
        light: WeatherSnowflakeIcon20Light,
        regular: WeatherSnowflakeIcon20Regular,
        solid: WeatherSnowflakeIcon20Solid,
    },
    24: {
        regular: WeatherSnowflakeIcon24Regular,
        solid: WeatherSnowflakeIcon24Solid,
    },
    32: {
        regular: WeatherSnowflakeIcon32Regular,
    },
    64: {
        regular: WeatherSnowflakeIcon64Regular,
    },
};
export var WeatherSnowflakeIcon = forwardRef('WeatherSnowflakeIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
